import React, { useCallback, useMemo, useState } from 'react';
import { dialogContext, type DialogContext } from './dialog-context';
// import V2CreateTaskDialog from '@/features/tasks/components/v2-create-task-dialog/v2-create-task-dialog';

export default function DialogProvider({ children }: React.PropsWithChildren) {
  /**Create Task Dialog */
  // const [isOpenCreateTaskDialog, setIsOpenCreateTaskDialog] =
  //   useState<boolean>(false);
  // const openCreateTaskDialog: DialogContext['openCreateTaskDialog'] =
  //   useCallback(_props => {
  //     setIsOpenCreateTaskDialog(true);
  //   }, []);
  // const closeCreateTaskDialog = useCallback(() => {
  //   setIsOpenCreateTaskDialog(false);
  // }, []);

  // /**Update Task Dialog */
  // /**Create Task Dialog */
  // const [isOpenUpdateTaskDialog, setIsOpenUpdateTaskDialog] =
  //   useState<boolean>(false);
  // const openUpdateTaskDialog = useCallback(() => {
  //   setIsOpenCreateTaskDialog(true);
  // }, []);
  // const closeUpdateTaskDialog = useCallback(() => {
  //   setIsOpenCreateTaskDialog(false);
  // }, []);

  // /**Delete Task Dialog */
  // const [isOpenDeleteTaskDialog, setIsOpenDeleteTaskDialog] =
  //   useState<boolean>(false);
  // const openDeleteTaskDialog = useCallback(() => {
  //   setIsOpenDeleteTaskDialog(true);
  // }, []);
  // const closeDeleteTaskDialog = useCallback(() => {
  //   setIsOpenDeleteTaskDialog(false);
  // }, []);

  const value = useMemo(() => {
    return {
      // Create Task Dialog
      // isOpenCreateTaskDialog,
      // openCreateTaskDialog,
      // closeCreateTaskDialog,
    };
  }, []);

  return (
    <dialogContext.Provider value={value}>
      {children}
      {/* <V2CreateTaskDialog dialog={{ open: isOpenCreateTaskDialog }} /> */}
    </dialogContext.Provider>
  );
}
